"use strict";
// IMPORTS
// Required libraries that are imported for side-effects. Polyfills and shims go here.
// TODO: Most of these polyfills are actually used by Kaavio. Be sure to include them when separating
require("document-register-element");
require("web-animations-js");
require("whatwg-fetch");
// Import styles
// TODO: Use material design
// TODO: Use shadow DOM to encapsulate styles
// TODO: State in docs that Webpack/browserify will automatically bring styles in when bundling
require("roboto-fontface/css/roboto/roboto-fontface.css");
// Import internal libraries for side-effects.
require("./wrappers/pvjs.webcomponent"); // TODO: Check this registers the component in browsers
// Exports
var vanilla_1 = require("./wrappers/vanilla");
exports.loadDiagram = vanilla_1.loadDiagram;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsVUFBVTtBQUNWLHNGQUFzRjtBQUN0RixxR0FBcUc7QUFDckcscUNBQW1DO0FBQ25DLDZCQUEyQjtBQUMzQix3QkFBc0I7QUFFdEIsZ0JBQWdCO0FBQ2hCLDRCQUE0QjtBQUM1Qiw2Q0FBNkM7QUFDN0MsK0ZBQStGO0FBQy9GLDBEQUF3RDtBQUV4RCw4Q0FBOEM7QUFDOUMsd0NBQXNDLENBQUMsdURBQXVEO0FBRTlGLFVBQVU7QUFDViw4Q0FBK0M7QUFBdkMsZ0NBQUEsV0FBVyxDQUFBIn0=


//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 692
// module chunks = 0